import React, { useState, useEffect } from 'react';
import '../../../pages/admin/admin_assets/css/OtpScreen.css';

const OtpScreen = ({ onBack }) => {
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [timeLeft, setTimeLeft] = useState(60);

    useEffect(() => {
        if (timeLeft > 0) {
            const timerId = setInterval(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearInterval(timerId);
        }
    }, [timeLeft]);

    const handleOtpChange = (value, index) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
    };

    return (
        <div className="otp-screen">
            <span className="back-link" onClick={onBack}>Back</span>
            <h1 className="otp-heading">Authenticate your account</h1>
            <p className="otp-paragraph mt-2 mb-4">We’ve emailed you a code to <strong>xyz@outlook.com</strong>.<br/>Enter it in the space below.</p>
            
            <label className="text-left d-block" htmlFor="otp-input">6-digit code</label>

            <div className="otp-input-container">
                {otp.map((digit, index) => (
                    <input
                        key={index}
                        type="text"
                        className="otp-input"
                        id="otp-input"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                    />
                ))}
            </div>
            
            <button className="otp-verify-button mt-5">Verify Code</button>
            <hr className="otp-hr" />
            <p className="otp-resend-text">
                Request new OTP again in {timeLeft < 10 ? `00:0${timeLeft}` : `00:${timeLeft}`}
            </p>
        </div>
    );
};

export default OtpScreen;
